module.exports = __webpack_public_path__ + "media/images/countrysquared/cf-1c3caeaf9e6f44a7e065a9c30dae3dc2.svg";